import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
    fetchPromptAfter,
    setPromptAfter,
} from '@finn-no/redux-career/actions/preference-prompt';

const REPROMPT_SHORT = 18 * 60 * 60 * 1000; // 18 hours
const REPROMPT_LONG = 3 * 31 * 24 * 60 * 60 * 1000; // ~ 3 months

export default WrappedComponent => {
    class CareerContainer extends Component {
        componentDidMount() {
            this.props.fetchPromptAfter();
        }

        handleCancelPreferences() {
            const promptAfter = new Date(
                Date.now() + REPROMPT_SHORT
            ).toISOString();
            this.props.setPromptAfter(promptAfter);
            // We currently don't have a way of notifying the user if the action
            // above fails, so let's just remove the view immediately
            this.props.onDismiss();
        }

        handleCompletePreferences() {
            const promptAfter = new Date(
                Date.now() + REPROMPT_LONG
            ).toISOString();
            this.props.setPromptAfter(promptAfter);
            if (this.props.onComplete) {
                this.props.onComplete();
            }
        }

        render() {
            return this.props.shouldPrompt ? (
                <WrappedComponent
                    {...this.props}
                    onCancel={this.handleCancelPreferences.bind(this)}
                    onComplete={this.handleCompletePreferences.bind(this)}
                />
            ) : null;
        }
    }

    CareerContainer.propTypes = {
        fetchPromptAfter: PropTypes.func.isRequired,
        setPromptAfter: PropTypes.func.isRequired,
        onDismiss: PropTypes.func.isRequired,
        onComplete: PropTypes.func.isRequired,
        shouldPrompt: PropTypes.bool.isRequired,
    };

    return connect(
        state => ({
            shouldPrompt: state.preferencePrompt.shouldPrompt,
        }),
        { fetchPromptAfter, setPromptAfter }
    )(CareerContainer);
};



// WEBPACK FOOTER //
// ./containers/create-prompt-container.jsx